
import TableUpdateBusnes from '../../component_businessPartner/business_partner/consult_business_partner';
import { Component } from "react";


export class UpdateBusnes extends Component {
  

  render() {

 
      
      return (    
      
      <div className="tc" >
        <TableUpdateBusnes></TableUpdateBusnes>

      </div>
          );
       }     
}



export default UpdateBusnes;
